<template>
  <div id="app">
    <router-view/>
    <!-- <modals-container/> -->
  </div>
</template>

<style>
/* @import '~vuetify/src/stylus/main'; */
#app {
  min-height: 100px;
  margin-top: 0;
  color: #2c3e50;
  font-family: "Avenir", Helvetica, Arial, sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  margin: 0;
}
.center {
  margin: auto;
}
.center {
  display: block;
  width: 15%;
  margin-right: auto;
  margin-left: auto;
}
.el-pagination.is-background {
  padding-top: 13px;
}
label.el-form-item__label {
  padding-bottom: 0 !important;
  color: #444;
}
.el-select.el-select--mini,
.el-select.el-select--small,
.el-date-editor.el-range-editor.el-input__inner.el-date-editor--datetimerange.el-range-editor--mini {
  width: 100%;
  max-width: 100%;
}
/* .el-select.el-select--small {
  width: 100%;
  max-width: 100%;
} */
.el-date-editor.el-range-editor.el-input__inner.el-date-editor--datetimerange.el-range-editor--mini {
  width: 100%;
  max-width: 100%;
}
.el-date-editor.el-range-editor.el-input__inner.el-date-editor--datetimerange.el-range-editor--small {
  width: 100%;
  max-width: 100%;
}
.el-input-number.el-input-number--mini.is-without-controls {
  width: 100%;
  max-width: 100%;
}
.el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange.el-range-editor--mini {
  width: 100%;
  max-width: 100%;
}
.el-date-editor.el-input.el-input--mini.el-input--prefix.el-input--suffix.el-date-editor--month,
.el-date-editor.el-input.el-input--mini.el-input--prefix.el-input--suffix.el-date-editor--year {
  /* width: 100%;
  max-width: 100%; */
}
.box-header.with-border {
  border-bottom: 1px solid #f4f4f4;
}

.el-upload__input {
  display: none !important;
}
.btn_padding {
  padding: 6px 7px;
  margin-right: 5px;
}
.circular--landscape {
  position: relative;
  display: inline-block;
  overflow: hidden;
  width: 300px;
  height: 300px;
  border-radius: 50%;
}
.circular--landscape img {
  width: auto;
  height: 100%;
  margin-left: -140px;
}
.set-box-center {
  margin-top: 10%;
}
.new-space {
  padding-top: 16px;
}
.not_display {
  display: none;
}
.el-form-item.is-required .el-form-item__label:before {
  display: none;
}
.el-form-item.is-required .el-form-item__label:after {
  content: '*';
  color: #f56c6c;
  margin-left: 4px;
}
</style>
<script>
export default {
  data() {
    return {
      //  socket : io('localhost:3000'),
      // tokenId:'H5hO1bH61MRkPqTq0zglMq2xzZHowOCMxKyy26ILKju4qZZLIghZOh6FkztUwrlG'
    };
  },
  created() {
    //     this.socket.on("kkk",(res)=>{
    // console.log("kkk: "+res)
    //     })
    // this.socket.on('SUCCESS', function(msg) {
    //             console.log(msg);
    // });
    // this.socket.on('UPDATE_MONEY', function(msg) {
    //             console.log(msg);
    // });
    // this.socket.emit('authentication', {id: this.tokenId });
  },
  methods: {
    sendMessage(e) {
      e.preventDefault();
    }
  }
};
</script>

